/* ---------------------------------------------------------------------------
   Header search: open / close.

   Previously TWO identical handlers were bound to '.header_search svg' and each
   one ran $(document).find('.header_search_form').addClass('active-form') - i.e.
   it opened *every* search form on the page (the desktop one, the mobile-menu
   one and the mobile one). Each .form_search_bar is a position:fixed,
   100%x100% overlay with z-index 9999, so activating more than one stacked
   several search bars on top of each other and the UI looked duplicated /
   jumbled.

   The open is now scoped to the single .header_search_form that belongs to the
   trigger's own .header_search region, and any other form is explicitly closed
   first, so exactly one search bar can ever be active.
   --------------------------------------------------------------------------- */

// Trigger that opened the current overlay, so focus can be handed back on close.
var headerSearchLastTrigger = null;

function clearPredictiveResults() {
  $('#PredictiveWrapper').addClass('hide');
  $(document).find('#PredictiveResults [data-type-pages]>ul').empty();
  $(document).find('#PredictiveResults [data-type-products]>.grid').empty();
  $(document).find('#PredictiveResults [data-type-collections]>ul').empty();
}

function openHeaderSearch($trigger) {
  var $form = $trigger.closest('.header_search').find('.header_search_form').first();
  if (!$form.length) { return; }

  // Never leave a second overlay active.
  $('.header_search_form').not($form).removeClass('active-form');
  $('.js-header-search-open').not($trigger).attr('aria-expanded', 'false');

  $form.addClass('active-form');
  $trigger.attr('aria-expanded', 'true');
  headerSearchLastTrigger = $trigger;
  $('body').css('overflow', 'hidden');

  // Focus the field of the form we just opened. This used to be hard-coded to
  // #searchInput-desktop, so the mobile region's field never received focus.
  setTimeout(function () {
    $form.find('.search-box').first().trigger('focus');
  }, 350);
}

function closeHeaderSearch() {
  $(document).find('.header_search_form').removeClass('active-form');
  $('.js-header-search-open').attr('aria-expanded', 'false');
  $('body').css('overflow', 'auto');
  clearPredictiveResults();

  // Return focus to the icon that opened the overlay, otherwise focus falls to
  // <body> and Tab / Shift+Tab restart from the top of the document.
  if (headerSearchLastTrigger && headerSearchLastTrigger.length && headerSearchLastTrigger.is(':visible')) {
    headerSearchLastTrigger.trigger('focus');
  }
  headerSearchLastTrigger = null;
}

$(document).on('click', '.js-header-search-open', function (e) {
  e.preventDefault();
  openHeaderSearch($(this));
});

$(document).on('click', '.close_form', function () {
  closeHeaderSearch();
});

// Escape closes the overlay, matching the mobile search panel's behaviour.
$(document).on('keydown', function (e) {
  if (e.key !== 'Escape' && e.keyCode !== 27) { return; }
  if ($('.header_search_form.active-form').length) {
    closeHeaderSearch();
  }
});

$(document).on('click', 'button[data-predictive-search-button]', function () {
  // Scoped to the open form - '.hidden_submit' matches one button per rendered
  // search form, so an unscoped trigger fired a click on all of them.
  $('.header_search_form.active-form .hidden_submit').first().trigger('click');
});

var queryVal = '';

function predictiveSearch(This) {
  $(document).find('#PredictiveResults [data-type-pages]>ul').empty();
  $(document).find('#PredictiveResults [data-type-products]>.grid').empty();
  $(document).find('#PredictiveResults [data-type-collections]>ul').empty();
  var q = $(This).val();
  var b = '&resources[type]=product,page,collection'
  $.ajax('/search/suggest.json?q=' + q + b,{
    type: 'GET',
    dataType: 'json',
    success: function(response) {
        var productSuggestions = response.resources.results.products;
        var collectionSuggestions = response.resources.results.collections;
        var pagesSuggestions = response.resources.results.pages;
        if (productSuggestions.length > 0) {
          $('#PredictiveWrapper').removeClass('hide');
          var firstProductSuggestion = productSuggestions[0];
          var productResult = `<div class="grid__item grid-product small--one-half medium-up--one-quarter aos-animate">
                                    <div class="grid-product__content">
                                      <a href="${firstProductSuggestion.url}" class="grid-product__link" data-samitapbl-handle="${firstProductSuggestion.handle}">
                                        <div class="grid-product__image-mask">
                                          <div class="grid__image-ratio grid__image-ratio--square">
                                            <img class="grid__image-contain lazyautosizes lazyloaded"  src="${firstProductSuggestion.featured_image.url}">
                                          </div>
                                        </div>
                                        <div class="grid-product__meta">
                                          <div class="grid-product__title">${firstProductSuggestion.title}</div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>`;
            $(document).find('#PredictiveResults [data-type-products]>.grid').append(productResult);
          }else{
            $('#PredictiveWrapper').addClass('hide');
          }

        if(collectionSuggestions.length > 0) {
          $('#PredictiveWrapper').removeClass('hide');
          var firstCollectionSuggestion = collectionSuggestions[0];
          var collectionResult = `<li>
                                      <a href="${firstCollectionSuggestion.url}">${firstCollectionSuggestion.title}</a>
                                    </li>`;
          $(document).find('#PredictiveResults [data-type-collections]>ul').append(collectionResult);
        }else{
          $('#PredictiveWrapper').addClass('hide');
        }

        if(pagesSuggestions.length > 0) {
          $('#PredictiveWrapper').removeClass('hide');
          var firstPagesSuggestion = pagesSuggestions[0];
          var pageResult = `<li>
                                <a href="${firstPagesSuggestion.url}">${firstPagesSuggestion.title}</a>
                              </li>`;
          $(document).find('#PredictiveResults [data-type-pages]>ul').append(pageResult);
        }else{
          $('#PredictiveWrapper').addClass('hide');
        }
    }
  });
}

$(document).on('input', '#searchInput', function() {
  if($(this).val() != ''){
    predictiveSearch(this);
  }else{
  $('#PredictiveWrapper').addClass('hide');
  $(document).find('#PredictiveResults [data-type-pages]>ul').empty();
  $(document).find('#PredictiveResults [data-type-products]>.grid').empty();
  $(document).find('#PredictiveResults [data-type-collections]>ul').empty();
  }
});
